import api, { openApi } from "../../services/api";

const useSettings = () => {
  const getAll = async (params) => {
    const { data } = await api.request({
      url: "/settings",
      method: "GET",
      params,
    });
    return data;
  };

  const update = async (data) => {
    const { data: responseData } = await api.request({
      url: `/settings/${data.key}`,
      method: "PUT",
      data,
    });
    console.log(responseData);
    return responseData;
  };

  const get = async (param) => {
    const { data } = await api.request({
      url: `/setting/${param}`,
      method: "GET",
    });
    return data;
  };

  const getPublicSetting = async (key, companyIdOverride) => {
    const params = {
      token: "wtV"
    };

    // Injeta o companyId do usuário logado (quando houver) pra que o
    // whitelabel respeite a empresa atual em vez de cair sempre no tenant 1.
    if (companyIdOverride) {
      params.companyId = companyIdOverride;
    } else {
      try {
        const cachedUser = localStorage.getItem("user");
        if (cachedUser) {
          const parsed = JSON.parse(cachedUser);
          if (parsed && parsed.companyId) {
            params.companyId = parsed.companyId;
          }
        }
      } catch (e) {
        // localStorage indisponível / JSON inválido — segue sem companyId
      }
    }

    const { data } = await openApi.request({
        url: `/public-settings/${key}`,
        method: 'GET',
        params
    });
    return data;
  };

  return {
    getAll,
    update,
    get,
    getPublicSetting,
  };
};

export default useSettings;
